import { authenticationService } from "./authentication.service";

import { handleResponse } from "../_helpers/handle-response";

function getToken() {
  // return authorization header with jwt token
  //const currentUser = authenticationService.currentUserValue;
  if (
    authenticationService.currentDataValue !== undefined &&
    authenticationService.currentDataValue !== null &&
    authenticationService.currentDataValue.access_token !== undefined
  ) {
    return `Bearer ${authenticationService.currentDataValue.access_token}`;
  } else {
    return "";
  }
}

const mainApiUrl = process.env.REACT_APP_MAIN_API;
//const mainApiUrl = "https://api.definitivechoice.com/qa-definitiveapi.core";
//const mainApiUrl = "https://secure.bowwave.com/DefinitiveAPI.Core";

const handleError = (error) => {
  //alert('handleError');
  console.log(
    "----------------------------------ERROR----------------------------"
  );
  console.log(error);
  console.log(
    "----------------------------------ERROR----------------------------"
  );
};

///////////////////////////////ACTIONS////////////////////////////////////////////

export const getPageText = async (pageName, section, userId, scenarioId) => {
  var response = await fetch(
    `${mainApiUrl}/api/Home/GetAssistanceNote?pageName=${pageName}&section=${section}&userId=${userId}&scenarioId=${scenarioId}`,
    getRequestOptions
  );
  var handledResponse = handleResponse(response);
  return handledResponse;
};

///////////////////////////////ACTIONS END////////////////////////////////////////////

const getRequestOptions = () => {
  return {
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: getToken() },
  };
};

const deleteRequestOptions = () => {
  return {
    method: "DELETE",
    headers: { "Content-Type": "application/json", Authorization: getToken() },
  };
};

const postRequestOptions = (data) => {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: getToken() },
    body: JSON.stringify(data),
  };
};

const putRequestOptions = (data) => {
  return {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: getToken() },
    body: JSON.stringify(data),
  };
};

//fileType can be:
//0 - Document metric for alternative
//1 - Image metric for alternative
const uploadFile = (
  userId,
  fileType,
  file,
  partnerAlternativeId,
  partnerMetricId
) => {
  var data = new FormData();
  data.append("file", file);
  return fetch(
    `${mainApiUrl}/api/File/UploadMetricFile/${userId}?fileType=${fileType}&partnerAlternativeId=${partnerAlternativeId}&partnerMetricId=${partnerMetricId}`,
    {
      method: "POST",
      headers: {
        Authorization: getToken(),
      },
      body: data,
    }
  )
    .then(handleResponse)
    .then((r) => {
      return r;
    }, handleError);
};

const uploadUsers = (userId, partnerId, sendInvitation, file) => {
  var data = new FormData();
  data.append("file", file);
  return fetch(
    `${mainApiUrl}/api/File/UploadUsers/${userId}/${partnerId}/${sendInvitation}`,
    {
      method: "POST",
      headers: {
        Authorization: getToken(),
      },
      body: data,
    }
  )
    .then(handleResponse)
    .then(
      (r) => {
        return r;
      },
      (error) => {
        throw error;
      }
    );
};

const uploadAlternatives = (userId, partnerScenarioId, file) => {
  var data = new FormData();
  data.append("file", file);
  return fetch(
    `${mainApiUrl}/api/File/UploadAlternatives/${userId}/${partnerScenarioId}`,
    {
      method: "POST",
      headers: {
        Authorization: getToken(),
      },
      body: data,
    }
  )
    .then(handleResponse)
    .then(
      (r) => {
        return r;
      },
      (error) => {
        throw error;
      }
    );
};

const getPartnerAlternativesExcelTemplate = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/File/GetAlternativesTemplate/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then((resp) => {
      return resp.blob();
    })
    .then((blob) => {
      return blob;
    });
};

const getUsersExcelTemplate = () => {
  return fetch(`${mainApiUrl}/api/File/GetUsersTemplate`, getRequestOptions())
    .then((resp) => {
      return resp.blob();
    })
    .then((blob) => {
      return blob;
    });
};

const getUserPhotoBase64 = (userId) => {
  return fetch(
    `${mainApiUrl}/api/User/GetUserPhotoBase64/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getUserUploadExcelTemplateUrl = () => {
  return fetch(
    `${mainApiUrl}/api/Home/GetUserUploadExcelTemplate`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getBraintreeClientToken = (userId) => {
  return fetch(
    `${mainApiUrl}/api/User/GetBraintreeClientToken?userId=${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getBraintreePlans = () => {
  return fetch(
    `${mainApiUrl}/api/User/GetPlans?planType=1`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getBraintreePlansForPartner = (numberOfUsers, templatesOnly) => {
  return fetch(
    `${mainApiUrl}/api/User/GetPlans?planType=2&numberOfUsers=${numberOfUsers}&templatesOnly=${templatesOnly}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getBraintreeActiveSubscriptions = (userId) => {
  return fetch(
    `${mainApiUrl}/api/User/GetBraintreeActiveSubscriptions/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const createBraintreeTransaction = (email, nonce, amount, planId) => {
  return fetch(
    `${mainApiUrl}/api/User/CreateTransaction`,
    postRequestOptions({ email, nonce, amount, planId })
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const cancelSubscription = (userId, subscriptionId) => {
  return fetch(
    `${mainApiUrl}/api/User/CancelSubscription/${userId}/${subscriptionId}`,
    postRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const updateUserPhotoBase64 = (userId, base64) => {
  return fetch(
    `${mainApiUrl}/api/User/UpdateUserPhotoBase64/${userId}`,
    postRequestOptions({ base64: base64 })
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getAllPartners = () => {
  return fetch(`${mainApiUrl}/api/Partner/GetAllPartners`, getRequestOptions())
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getUsersByPartnerScenario = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetUsersByPartnerScenario/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerUsers = (partnerId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerUsers/${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getUsers = (partnerId) => {
  return fetch(
    `${mainApiUrl}/api/User/GetUsers/${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getUserById = (userId) => {
  return fetch(
    `${mainApiUrl}/api/User/GetUserById/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerUserByID = (userId, partnerId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerUserByID/${userId}/${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getScenariosByUserPartner = (userId, partnerId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/getScenariosByUserPartner/${userId}/${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const archiveScenarios = (userId, partnerId, partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/ArchiveScenarios/${userId}/${partnerId}/${partnerScenarioId}`,
    postRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const generateScenarios = (userId, partnerId, partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GenerateScenarios/${userId}/${partnerId}/${partnerScenarioId}`,
    postRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getScenariosByUser = (userId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/getScenariosByUser/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnersByUser = (userId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/getPartnersByUser/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const copyPartnerScenario = (userId, partnerScenarioId, copyUsers) => {
  return fetch(
    `${mainApiUrl}/api/Partner/CopyPartnerScenario/${userId}/${partnerScenarioId}/${copyUsers}`,
    postRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getScenarioByIdFull = (scenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GetScenarioByID_Full/${scenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getScenarioById = (scenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GetScenarioByID/${scenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerById = (partnerId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartner/${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerScenariosByPartnerId = (partnerId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerScenariosByPartner/${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerScenarioById = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerScenario/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerObjectiveById = (partnerObjectiveId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerObjective/${partnerObjectiveId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerObjectives = (partnerId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetObjectivesForPartner/${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerObjectivesByPartnerScenarioId = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerObjectivesByPartnerScenario/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerMetricsByPartnerScenario = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerMetricsByPartnerScenario/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerAlternativeRatingsByPartnerObjective = (partnerObjectiveId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerAlternativeRatingsByPartnerObjective/${partnerObjectiveId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerAlternativesByPartnerScenarioId = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerAlternativesByPartnerScenario/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerAlternativeById = (partnerAlternativeId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerAlternativeByID/${partnerAlternativeId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getParticipantsByPartnerScenarioId = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetParticipantsByPartnerScenario/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getParticipantById = (participantId) => {
  return fetch(
    `${mainApiUrl}/api/Participant/GetParticipantByID/${participantId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerMetricById = (partnerMetricId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerMetric/${partnerMetricId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getWebAppUrl = () => {
  return fetch(`${mainApiUrl}/api/User/GetWebAppUrl`, getRequestOptions())
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

function createPartner(userId, partner) {
  var payload = {
    partner,
    owner: {
      firstName: partner.firstName,
      lastName: partner.lastName,
      email: partner.email,
      password: partner.password,
    },
  };
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartner/${userId}`,
    postRequestOptions(payload)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePartner(userId, partner) {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartner/${userId}`,
    postRequestOptions(partner)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createPartnerScenario(userId, partnerScenario) {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerScenario/${userId}`,
    postRequestOptions(partnerScenario)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePartnerScenario(userId, partnerScenario) {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerScenario/${userId}`,
    postRequestOptions(partnerScenario)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deletePartnerScenario(userId, partnerScenario) {
  return fetch(
    `${mainApiUrl}/api/Partner/DeletePartnerScenario/${userId}`,
    postRequestOptions(partnerScenario)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createPartnerAlternative(userId, partnerAlternative) {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerAlternative/${userId}`,
    postRequestOptions(partnerAlternative)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePartnerAlternative(userId, partnerAlternative) {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerAlternative/${userId}`,
    postRequestOptions(partnerAlternative)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deletePartnerAlternative(userId, partnerAlternative) {
  return fetch(
    `${mainApiUrl}/api/Partner/DeletePartnerAlternative/${userId}`,
    postRequestOptions(partnerAlternative)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createPartnerAlternativeMetric(partnerAlternativeMetric) {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerAlternativeMetric`,
    postRequestOptions(partnerAlternativeMetric)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePartnerAlternativeMetric(userId, partnerAlternativeMetric) {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerAlternativeMetric/${userId}`,
    postRequestOptions(partnerAlternativeMetric)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createParticipant(userId, partnerScenarioId, participant) {
  return fetch(
    `${mainApiUrl}/api/Participant/CreatePartnerParticipant/${userId}/${partnerScenarioId}`,
    postRequestOptions(participant)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updateParticipant(userId, participant) {
  return fetch(
    `${mainApiUrl}/api/Participant/UpdateParticipant/${userId}`,
    postRequestOptions(participant)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createPartnerMetric(userId, partnerMetric) {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerMetric/${userId}`,
    postRequestOptions(partnerMetric)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePartnerMetric(userId, partnerMetric) {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerMetric/${userId}`,
    postRequestOptions(partnerMetric)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deletePartnerMetric(userId, partnerMetric) {
  return fetch(
    `${mainApiUrl}/api/Partner/DeletePartnerMetric/${userId}`,
    postRequestOptions(partnerMetric)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createPartnerObjective(userId, partnerObjective) {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerObjective/${userId}`,
    postRequestOptions(partnerObjective)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePartnerObjective(userId, partnerObjective) {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerObjective/${userId}`,
    postRequestOptions(partnerObjective)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deletePartnerObjective(userId, partnerObjective) {
  return fetch(
    `${mainApiUrl}/api/Partner/DeletePartnerObjective/${userId}`,
    postRequestOptions(partnerObjective)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deleteParticipant(userId, participantId) {
  return fetch(
    `${mainApiUrl}/api/Participant/DeleteParticipant/${userId}/${participantId}`,
    deleteRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deletePartnerUser(updateUserId, partnerId, userIdToDelete) {
  return fetch(
    `${mainApiUrl}/api/Partner/DeletePartnerUser/${updateUserId}?userIdToRemove=${userIdToDelete}&partnerId=${partnerId}`,
    deleteRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createPartnerAlternativeRating(rating) {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerAlternativeRating`,
    postRequestOptions(rating)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePartnerAlternativeRating(partnerAlternativeRating) {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerAlternativeRating`,
    postRequestOptions(partnerAlternativeRating)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

const getPartnerChart = (partnerScenarioId, objtype, consistencyRate) => {
  return fetch(
    `${mainApiUrl}/api/Chart/GetPartnerChart_ObjectiveAvg/${partnerScenarioId}/${objtype}/${consistencyRate}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerChartAltAvg = (partnerScenarioId, altType, limit) => {
  return fetch(
    `${mainApiUrl}/api/Chart/GetPartnerChart_AlternativeAvg/${partnerScenarioId}/${altType}/${limit}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerChartNumDecisions = (partnerScenarioId, daysback) => {
  return fetch(
    `${mainApiUrl}/api/Chart/GetPartnerChart_NumDecisions/${partnerScenarioId}/${daysback}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getScenarioReportQueryParam = (userId) => {
  return fetch(
    `${mainApiUrl}/api/Report/GetScenarioReportQueryParam?userId=${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getScenarioReportUrl = (userId, scenarioId, reportQueryParam) => {
  return `${mainApiUrl}/api/Report/GetScenarioReport?scenarioId=${scenarioId}&userId=${userId}&guid=${reportQueryParam}`;
};

const getConsensusReportUrl = (userId, scenarioId, reportQueryParam) => {
  return `${mainApiUrl}/api/Report/GetConsensusReport?scenarioId=${scenarioId}&userId=${userId}&guid=${reportQueryParam}`;
};

const getTemplateSetupReportUrl = (userId, partnerScenarioId, guid) => {
  return `${mainApiUrl}/api/Report/GetTemplateSetupReport?partnerScenarioId=${partnerScenarioId}&userId=${userId}&guid=${guid}`;
};

const getSurveyReport = (
  userId,
  partnerId,
  partnerScenarioId,
  guid,
  userIds
) => {
  return fetch(
    `${mainApiUrl}/api/Report/GetSurveyReport/${userId}/${partnerId}/${partnerScenarioId}?guid=${guid}`,
    postRequestOptions({ userIds })
  )
    .then((resp) => {
      return resp.blob();
    })
    .then((blob) => {
      return blob;
    });
};

const getTemplateOverviewReport = (userId,partnerId, guid) => {
  return fetch(
    `${mainApiUrl}/api/Report/GetTemplateOverviewReport/${userId}/${partnerId}?guid=${guid}`,
    getRequestOptions()
  )
    .then((resp) => {
      return resp.blob();
    })
    .then((blob) => {
      return blob;
    });
};

const getPartnerScenariosByUserId = (userId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerScenariosByUser/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const updatePartnerScenarioUser = (userId, partnerScenarioId, isSelected) => {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerScenarioUser/${userId}/${partnerScenarioId}/${isSelected}`,
    putRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const createPartnerScenarioUser = (userId, partnerScenarioId, partnerUser) => {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerScenarioUser/${userId}/${partnerScenarioId}`,
    postRequestOptions(partnerUser)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const createPartnerUser = (userId, partnerUser) => {
  return fetch(
    `${mainApiUrl}/api/Partner/CreatePartnerUser/${userId}`,
    postRequestOptions(partnerUser)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const updatePartnerUser = (userId, partnerUser) => {
  return fetch(
    `${mainApiUrl}/api/Partner/UpdatePartnerUser/${userId}`,
    putRequestOptions(partnerUser)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const resendInvitation = (userId, invitedUserId, partnerId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/ResendInvitation/${userId}?invitedUserId=${invitedUserId}&partnerId=${partnerId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const resendInvitationBulk = (userId, users) => {
  return fetch(
    `${mainApiUrl}/api/Partner/ResendInvitationBulk/${userId}`,
    postRequestOptions(users)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

function updateUser(userId, user) {
  return fetch(
    `${mainApiUrl}/api/User/UpdateUser/${userId}`,
    postRequestOptions(user)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function getUserByEmail(email) {
  return fetch(
    `${mainApiUrl}/api/User/GetUserByEmail?email=${email}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function getTemplateCategories() {
  return fetch(
    `${mainApiUrl}/api/Partner/GetAllTemplateCategories`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function verifyTransfer(guid) {
  return fetch(
    `${mainApiUrl}/api/User/VerifyTransfer?guid=${guid}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function cleanExpiredTrials() {
  return fetch(
    `${mainApiUrl}/api/Admin/CleanExpiredTrials`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function checkExpiringTrials(days) {
  return fetch(
    `${mainApiUrl}/api/Admin/CheckExpiringTrials?daysToExpiration=${days}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function checkCancelledSubscriptions() {
  return fetch(
    `${mainApiUrl}/api/Admin/CheckCancelledSubscriptions`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

const getScenariosByPartnerScenario = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GetScenariosByPartnerScenario/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const uploadImage = (userId, base64, fileName) => {
  return fetch(
    `${mainApiUrl}/api/File/UploadImage/${userId}`,
    postRequestOptions({ base64: base64, fileName: fileName })
  )
    .then(handleResponse)
    .then((r) => {
      return r;
    }, handleError);
};

const getPhasesByPartnerScenarioID = (partnerScenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GetPhasesByPartnerScenarioID/${partnerScenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getMilestonesByPhases = (phaseIDs) => {
  let ids = phaseIDs;
  if (Array.isArray(phaseIDs)) ids = phaseIDs.join(",");

  ids += ",0"; // TBD phase

  return fetch(
    `${mainApiUrl}/api/Scenario/GetMilestonesByPhases/${ids}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getMilestoneTypes = () => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GetMilestoneTypes`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getFieldsByMilestones = (milestonesIDs) => {
  let ids = milestonesIDs;
  if (Array.isArray(milestonesIDs)) ids = milestonesIDs.join(",");

  ids += ",0"; // TBD milestone

  return fetch(
    `${mainApiUrl}/api/Scenario/GetFieldsByMilestones/${ids}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

function createPhase(phase) {
  return fetch(
    `${mainApiUrl}/api/Scenario/CreatePhase`,
    postRequestOptions(phase)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updatePhase(phase) {
  return fetch(
    `${mainApiUrl}/api/Scenario/UpdatePhase`,
    postRequestOptions(phase)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deletePhase(phaseID) {
  return fetch(
    `${mainApiUrl}/api/Scenario/DeletePhase/${phaseID}`,
    postRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createMilestone(milestone) {
  return fetch(
    `${mainApiUrl}/api/Scenario/CreateMilestone`,
    postRequestOptions(milestone)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updateMilestone(milestone) {
  return fetch(
    `${mainApiUrl}/api/Scenario/UpdateMilestone`,
    postRequestOptions(milestone)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deleteMilestone(milestoneID) {
  return fetch(
    `${mainApiUrl}/api/Scenario/DeleteMilestone/${milestoneID}`,
    postRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function createField(field) {
  return fetch(
    `${mainApiUrl}/api/Scenario/CreateField`,
    postRequestOptions(field)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function updateField(field) {
  return fetch(
    `${mainApiUrl}/api/Scenario/UpdateField`,
    postRequestOptions(field)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

function deleteField(fieldID) {
  return fetch(
    `${mainApiUrl}/api/Scenario/DeleteField/${fieldID}`,
    postRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
}

const getFieldsByPartnerScenario = (partnerScenarioID) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GetFieldsByPartnerScenario/${partnerScenarioID}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getAnswersForField = (fieldID) => {
  return fetch(
    `${mainApiUrl}/api/Scenario/GetAnswersForField/${fieldID}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getObjectivesByScenario_UserScore = (scenarioId, userId) => {
  return fetch(
    `${mainApiUrl}/api/Objective/GetObjectivesByScenario_UserScore/${scenarioId}/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getAlternativeScoresByScenario_UserScores = (scenarioId, userId) => {
  return fetch(
    `${mainApiUrl}/api/Alternative/GetAlternativeScoresByScenario_UserScores/${scenarioId}/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getStackedBarChartByScenario_UserScores = (scenarioId, userId) => {
  return fetch(
    `${mainApiUrl}/api/Chart/GetStackedBarByScenarioID_UserScores/${scenarioId}/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getQuadrantChartByScenario_UserScores = (scenarioId, userId) => {
  return fetch(
    `${mainApiUrl}/api/Chart/GetQuadrantChart_UserScores/${scenarioId}/${userId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getPartnerAlternativesByScenario = (scenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Partner/GetPartnerAlternativesByScenario/${scenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getAlternativesByScenario = (scenarioId) => {
  return fetch(
    `${mainApiUrl}/api/Alternative/GetAlternativesByScenario/${scenarioId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const createAlternative = (userId, scenarioId, alternative) => {
  let alt = {
    alternativeName:
      alternative.partnerAlternativeName || alternative.alternativeName,
    scenarioID: scenarioId,
    alternativeNum: 0,
    description: alternative.description,
    cost: alternative.cost,
    partnerAlternativeID: alternative.partnerAlternativeID || 0,
  };
  if (alternative.alternativeAPIMetrics) {
    alt.alternativeAPIMetrics = JSON.stringify(
      alternative.alternativeAPIMetrics
    );
  }

  return fetch(
    `${mainApiUrl}/api/Alternative/CreateAlternative/${userId}`,
    postRequestOptions(alt)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const updateAlternative = (userId, alternative) => {
  return fetch(
    `${mainApiUrl}/api/Alternative/UpdateAlternative/${userId}`,
    postRequestOptions(alternative)
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const deleteAlternative = (userId, alternativeId) => {
  return fetch(
    `${mainApiUrl}/api/Alternative/DeleteAlternative/${userId}/${alternativeId}`,
    deleteRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

const getAPIAlternativeMetrics = (alternativeId) => {
  return fetch(
    `${mainApiUrl}/api/Alternative/GetAPIAlternativeMetrics/${alternativeId}`,
    getRequestOptions()
  )
    .then(handleResponse)
    .then((data) => {
      return data;
    }, handleError);
};

export const api = {
  mainApiUrl,
  cleanExpiredTrials,
  getAlternativeScoresByScenario_UserScores,
  getStackedBarChartByScenario_UserScores,
  getQuadrantChartByScenario_UserScores,
  checkExpiringTrials,
  checkCancelledSubscriptions,
  updateUser,
  getObjectivesByScenario_UserScore,
  getUserByEmail,
  getUserPhotoBase64,
  updateUserPhotoBase64,
  getAllPartners,
  getUsersByPartnerScenario,
  getPartnerById,
  getPartnerUsers,
  getPartnerScenariosByPartnerId,
  getSurveyReport,
  getTemplateOverviewReport,
  getPartnerScenariosByUserId,
  updatePartner,
  getPartnerScenarioById,
  getPartnerObjectivesByPartnerScenarioId,
  getPartnerMetricsByPartnerScenario,
  getPartnerAlternativesByPartnerScenarioId,
  getParticipantsByPartnerScenarioId,
  createPartnerScenario,
  updatePartnerScenario,
  deletePartnerScenario,
  getPartnerAlternativeById,
  createPartnerAlternative,
  updatePartnerAlternative,
  deletePartnerAlternative,
  getPartnerMetricById,
  createPartnerMetric,
  updatePartnerMetric,
  deletePartnerMetric,
  createPartnerObjective,
  updatePartnerObjective,
  deletePartnerObjective,
  getPartnerObjectiveById,
  getPartnerObjectives,
  getParticipantById,
  createParticipant,
  updateParticipant,
  deleteParticipant,
  updatePartnerAlternativeMetric,
  createPartnerAlternativeMetric,
  getPartnerAlternativeRatingsByPartnerObjective,
  createPartnerAlternativeRating,
  updatePartnerAlternativeRating,
  createPartner,
  getPartnerUserByID,
  getScenariosByUserPartner,
  archiveScenarios,
  generateScenarios,
  getPartnerChart,
  getPartnerChartAltAvg,
  getPartnerChartNumDecisions,
  getScenarioReportQueryParam,
  getScenarioReportUrl,
  getConsensusReportUrl,
  getTemplateSetupReportUrl,
  updatePartnerScenarioUser,
  createPartnerScenarioUser,
  createPartnerUser,
  updatePartnerUser,
  getUsers,
  getUserById,
  getScenarioByIdFull,
  getScenariosByUser,
  getPartnersByUser,
  copyPartnerScenario,
  getBraintreeClientToken,
  createBraintreeTransaction,
  getBraintreePlans,
  getBraintreeActiveSubscriptions,
  cancelSubscription,
  verifyTransfer,
  getBraintreePlansForPartner,
  getWebAppUrl,
  getTemplateCategories,
  resendInvitation,
  deletePartnerUser,
  uploadFile,
  uploadUsers,
  getUserUploadExcelTemplateUrl,
  getPartnerAlternativesExcelTemplate,
  uploadAlternatives,
  getUsersExcelTemplate,
  resendInvitationBulk,
  getScenariosByPartnerScenario,
  uploadImage,
  getPhasesByPartnerScenarioID,
  getMilestonesByPhases,
  getMilestoneTypes,
  getFieldsByMilestones,
  createPhase,
  updatePhase,
  deletePhase,
  createMilestone,
  updateMilestone,
  deleteMilestone,
  createField,
  updateField,
  deleteField,
  getFieldsByPartnerScenario,
  getAnswersForField,
  getScenarioById,
  getPartnerAlternativesByScenario,
  getAlternativesByScenario,
  createAlternative,
  updateAlternative,
  deleteAlternative,
  getAPIAlternativeMetrics,
};
